import axios from "axios";
import { baseURL } from "../utils/consts";

const generateTransferTicketOTP = async (
  eventId,
  uniqueHash,
  fullName,
  email
) => {
  const responseObject = {
    eventId,
    uniqueHash,
    fullName,
    email,
  };

  try {
    const response = await axios.post(
      `${baseURL}/invitedVia/expressEntry/transferTicket`,
      responseObject,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.data.payLoad;
    return data;
  } catch (err) {
    throw err;
  }
};

export default generateTransferTicketOTP;
